"use client";

import { useEffect } from "react";

export default function HomeEffects() {
    useEffect(() => {
        document.body.classList.add("select-none");
        return () => {
            document.body.classList.remove("select-none");
        };
    }, []);

    return null;
}
